export default "__VITE_ASSET__C7rgfwZ1__"